import { LinearGradient } from 'expo-linear-gradient';
import React from 'react';
import { Text, TouchableOpacity } from 'react-native';

import { styles } from './styles';

const GradientButton = ({ ...props }) => {
  return (
    <TouchableOpacity {...props}>
      <LinearGradient
        start={{ x: -1, y: 0 }}
        end={{ x: 1, y: 0 }}
        colors={["#196059", "#196059"]}
        style={styles.button}
      >
        <Text style={styles.text}>{props.children}</Text>
      </LinearGradient>
    </TouchableOpacity >
  );
}

export default GradientButton;